import { SortDirection } from 'constants/SortDirection';
import { action, computed, makeObservable } from 'mobx';
import { get, patch } from 'stores/_services/dataService';
import { NotificationType } from 'stores/_shared/Interfaces';
import BaseListStore from 'stores/BaseListStore';
import NotificationStore, { INotification } from 'stores/notification/NotificationStore';

export default class NotificationListStore extends BaseListStore<NotificationStore> {
    get notificationSettings(): INotification | undefined {
        return this.items[0]?.notification;
    }

    constructor() {
        super({
            itemStore: NotificationStore
        });

        makeObservable(this, {
            notificationSettings: computed,
            getNotifications: action,
            saveNotification: action
        });

        this.sortBy = 'userId';
        this.sortDirection = SortDirection.ASC;
    }

    async getNotifications(userId: string): Promise<void> {
        const options = {
            filter: {
                where: { userId, type: NotificationType.ALERT_DIGEST }
            }
        };

        const { data } = await get('schedulednotifications', options);

        this._updateData(data);
        this._updateIds(data, 0);
    }

    async saveNotification(payload: INotification): Promise<INotification | undefined> {
        const { data } = await patch('/schedulednotifications', payload);

        this._updateData(data);

        return data;
    }
}
